"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var visuallyHidden=function(){return"\n    position: absolute;\n    left: -10000px;\n    top: auto;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n  "};exports.default=visuallyHidden;


/** WEBPACK FOOTER **
 ** ./~/@vitalsource/vstui/styles/visuallyHidden.js
 **/